var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "app-container"
  }, [_c("div", {
    staticClass: "filter-header",
    staticStyle: {
      display: "flex",
      "justify-content": "space-between",
      "margin-bottom": "10px"
    }
  }, [_c("el-button", {
    attrs: {
      type: "primary",
      size: "mini"
    },
    on: {
      click: function ($event) {
        _vm.showFilters = !_vm.showFilters;
      }
    }
  }, [_vm._v(" Filters & More "), _c("i", {
    class: _vm.showFilters ? "el-icon-arrow-up" : "el-icon-arrow-down",
    staticStyle: {
      "margin-left": "5px"
    }
  })])], 1), _vm.showFilters ? _c("div", {
    staticClass: "filter-container"
  }, [_vm.currentView === "branches" ? _c("el-select", {
    staticClass: "filter-item",
    staticStyle: {
      width: "250px"
    },
    attrs: {
      filterable: "",
      clearable: "",
      loading: _vm.branchListLoading,
      placeholder: "Select Branch"
    },
    on: {
      change: _vm.fetchData
    },
    model: {
      value: _vm.branchId,
      callback: function ($$v) {
        _vm.branchId = $$v;
      },
      expression: "branchId"
    }
  }, _vm._l(_vm.branchList, function (b) {
    return _c("el-option", {
      key: b.id,
      attrs: {
        label: b.name,
        value: b.id
      }
    });
  }), 1) : _vm._e(), _vm.currentView === "products" ? _c("el-select", {
    staticClass: "filter-item",
    staticStyle: {
      width: "250px"
    },
    attrs: {
      filterable: "",
      clearable: "",
      remote: "",
      "remote-method": _vm.getProductList,
      loading: _vm.productListLoading,
      placeholder: "Select Product"
    },
    on: {
      change: function ($event) {
        _vm.listQuery.page = 1;
      }
    },
    model: {
      value: _vm.selectedProduct,
      callback: function ($$v) {
        _vm.selectedProduct = $$v;
      },
      expression: "selectedProduct"
    }
  }, _vm._l(_vm.products, function (product) {
    return _c("el-option-group", {
      key: product.id,
      attrs: {
        label: "Main Product"
      }
    }, [_c("el-option", {
      key: "product-" + product.id,
      attrs: {
        label: product.name,
        value: "product-" + product.id
      }
    }, [_c("span", {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(product.name))])]), product.productType !== "simple" && product.productsVariation && product.productsVariation.length ? _c("el-option-group", {
      key: "variations-label-" + product.id,
      attrs: {
        label: "Variations"
      }
    }, _vm._l(product.productsVariation, function (item) {
      return _c("el-option", {
        key: "variation-" + item.id,
        attrs: {
          label: product.name + "-" + item.name,
          value: "variation-" + item.id
        }
      });
    }), 1) : _vm._e()], 1);
  }), 1) : _vm._e(), _c("el-select", {
    staticClass: "filter-item",
    staticStyle: {
      width: "200px",
      "margin-right": "10px"
    },
    attrs: {
      clearable: "",
      filterable: "",
      placeholder: "Range"
    },
    on: {
      change: _vm.handleRangeFilter
    },
    model: {
      value: _vm.selectedRangeId,
      callback: function ($$v) {
        _vm.selectedRangeId = $$v;
      },
      expression: "selectedRangeId"
    }
  }, _vm._l(_vm.rangeList, function (range) {
    return _c("el-option", {
      key: range.id,
      attrs: {
        label: range.name,
        value: range.id
      }
    });
  }), 1), _c("el-select", {
    staticClass: "filter-item",
    staticStyle: {
      width: "200px",
      "margin-right": "10px"
    },
    attrs: {
      disabled: !_vm.selectedRangeId,
      clearable: "",
      filterable: "",
      placeholder: "Category"
    },
    on: {
      change: _vm.handleCategoryFilter
    },
    model: {
      value: _vm.selectedCategoryId,
      callback: function ($$v) {
        _vm.selectedCategoryId = $$v;
      },
      expression: "selectedCategoryId"
    }
  }, _vm._l(_vm.categoryList, function (category) {
    return _c("el-option", {
      key: category.id,
      attrs: {
        label: category.name,
        value: category.id
      }
    });
  }), 1), _c("el-select", {
    staticClass: "filter-item",
    staticStyle: {
      width: "200px",
      "margin-right": "10px"
    },
    attrs: {
      disabled: !_vm.selectedCategoryId,
      clearable: "",
      filterable: "",
      placeholder: "Sub Category"
    },
    on: {
      change: _vm.handleSubCategoryFilter
    },
    model: {
      value: _vm.selectedSubCategoryId,
      callback: function ($$v) {
        _vm.selectedSubCategoryId = $$v;
      },
      expression: "selectedSubCategoryId"
    }
  }, _vm._l(_vm.subCategoryList, function (category) {
    return _c("el-option", {
      key: category.id,
      attrs: {
        label: category.name,
        value: category.id
      }
    });
  }), 1), _c("el-button", {
    staticClass: "filter-item",
    attrs: {
      type: "warning",
      icon: "el-icon-download",
      size: "mini"
    },
    on: {
      click: _vm.exportExcel
    }
  }, [_vm._v(" Export to Excel ")])], 1) : _vm._e(), _c("div", {
    staticStyle: {
      "margin-bottom": "20px",
      display: "flex",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c("div", {
    staticClass: "breadcrumb-container",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_c("span", {
    staticStyle: {
      cursor: "pointer",
      color: "#409EFF",
      "font-weight": "bold"
    },
    on: {
      click: function ($event) {
        return _vm.navigateTo("branches");
      }
    }
  }, [_vm._v(" Branches ")]), _vm.selectedBranch ? _c("span", [_c("i", {
    staticClass: "el-icon-arrow-right",
    staticStyle: {
      margin: "0 8px",
      color: "#c0c4cc"
    }
  }), _c("span", {
    staticStyle: {
      cursor: "pointer",
      color: "#409EFF",
      "font-weight": "bold"
    },
    on: {
      click: function ($event) {
        return _vm.navigateTo("units");
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.selectedBranch.branch) + " (" + _vm._s(_vm.selectedBranch.branchCode) + ") ")])]) : _vm._e(), _vm.selectedUnit ? _c("span", [_c("i", {
    staticClass: "el-icon-arrow-right",
    staticStyle: {
      margin: "0 8px",
      color: "#c0c4cc"
    }
  }), _c("span", {
    staticStyle: {
      color: "#303133",
      "font-weight": "bold"
    }
  }, [_vm._v(" " + _vm._s(_vm.selectedUnit.unit) + " ")])]) : _vm._e()]), _c("div", {
    staticStyle: {
      display: "flex",
      "align-items": "center"
    }
  }, [_vm.currentView === "units" && _vm.selectedBranch ? _c("div", {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "14px",
      color: "#409EFF"
    }
  }, [_vm._v(" Branch Total: ₹ " + _vm._s(_vm.formatNumber(_vm.selectedBranch.branchTotalValue)) + " ")]) : _vm._e(), _vm.currentView === "products" && _vm.selectedUnit ? _c("div", {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "14px",
      color: "#67C23A"
    }
  }, [_vm._v(" Unit Total: ₹ " + _vm._s(_vm.formatNumber(_vm.selectedUnit.unitTotalValue)) + " ")]) : _vm._e()])]), _vm.currentView === "branches" ? _c("div", [_c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.listLoading,
      expression: "listLoading"
    }],
    key: "branches-table",
    staticStyle: {
      width: "100%",
      cursor: "pointer"
    },
    attrs: {
      data: _vm.reportData,
      border: "",
      fit: "",
      "highlight-current-row": "",
      "show-summary": true,
      "summary-method": _vm.getBranchSummary
    },
    on: {
      "row-click": _vm.selectBranch
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "Branch Name",
      prop: "branch",
      width: _vm.flexColumnWidth("branch", "Branch Name")
    }
  }), _c("el-table-column", {
    attrs: {
      label: "Branch Code",
      prop: "branchCode",
      width: _vm.flexColumnWidth("branchCode", "Branch Code")
    }
  }), _c("el-table-column", {
    attrs: {
      label: "Total Stock Value",
      prop: "branchTotalValue",
      align: "right",
      width: _vm.flexColumnWidth("branchTotalValue", "Total Stock Value")
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" ₹ " + _vm._s(_vm.formatNumber(scope.row.branchTotalValue)) + " ")];
      }
    }], null, false, 2399972952)
  }), _c("el-table-column", {
    attrs: {
      label: "90+ Days Value",
      prop: "branchTotal90PlusValue",
      align: "right",
      width: _vm.flexColumnWidth("branchTotal90PlusValue", "90+ Days Value")
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" ₹ " + _vm._s(_vm.formatNumber(scope.row.branchTotal90PlusValue)) + " ")];
      }
    }], null, false, 764369547)
  }), _c("el-table-column", {
    attrs: {
      label: "No. of days stock",
      prop: "noOfDaysStock",
      align: "center",
      width: "150px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(Math.round(scope.row.noOfDaysStock)) + " ")];
      }
    }], null, false, 3219145575)
  }), _c("el-table-column", {
    attrs: {
      label: "Action",
      width: "120px",
      align: "center"
    }
  }, [[_c("el-button", {
    attrs: {
      type: "text",
      size: "mini"
    }
  }, [_vm._v(" View Units ")])]], 2)], 1)], 1) : _vm.currentView === "units" && _vm.selectedBranch ? _c("div", [_c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.listLoading,
      expression: "listLoading"
    }],
    key: "units-table",
    staticStyle: {
      width: "100%",
      cursor: "pointer"
    },
    attrs: {
      data: _vm.unitsList,
      border: "",
      fit: "",
      "highlight-current-row": "",
      "show-summary": true,
      "summary-method": _vm.getUnitSummary
    },
    on: {
      "row-click": _vm.selectUnit
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "Unit Name",
      prop: "unit",
      width: _vm.flexColumnWidth("unit", "Unit Name")
    }
  }), _c("el-table-column", {
    attrs: {
      label: "Unit Stock Value",
      prop: "unitTotalValue",
      align: "right",
      width: _vm.flexColumnWidth("unitTotalValue", "Unit Stock Value")
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" ₹ " + _vm._s(_vm.formatNumber(scope.row.unitTotalValue)) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "90+ Days Value",
      prop: "unitTotal90PlusValue",
      align: "right",
      width: _vm.flexColumnWidth("unitTotal90PlusValue", "90+ Days Value")
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" ₹ " + _vm._s(_vm.formatNumber(scope.row.unitTotal90PlusValue)) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "Action",
      width: "120px",
      align: "center"
    }
  }, [[_c("el-button", {
    attrs: {
      type: "text",
      size: "mini"
    }
  }, [_vm._v(" View Products ")])]], 2)], 1)], 1) : _vm.currentView === "products" && _vm.selectedUnit ? _c("div", [_c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.listLoading,
      expression: "listLoading"
    }],
    key: "products-table",
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.getUnitProducts(),
      border: "",
      fit: "",
      "highlight-current-row": "",
      "show-summary": true,
      "summary-method": _vm.getProductSummary
    },
    on: {
      "sort-change": _vm.handleUnitSortChange
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "productName",
      label: "Product",
      width: _vm.flexColumnWidth("productName", "Product")
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "variationName",
      label: "Variation",
      width: _vm.flexColumnWidth("variationName", "Variation")
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "stock",
      label: "Stock",
      width: _vm.flexColumnWidth("stock", "Stock", 80),
      align: "center",
      sortable: "custom"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "slab30",
      label: "0-30 days",
      align: "right",
      width: "100px",
      sortable: "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("span", {
          staticStyle: {
            color: "#2e7d32",
            "font-weight": "bold"
          }
        }, [_vm._v(" " + _vm._s(scope.row.slab30) + " ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "slab45",
      label: "31-45 days",
      align: "right",
      width: "100px",
      sortable: "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("span", {
          staticStyle: {
            color: "#8b5a2b",
            "font-weight": "bold"
          }
        }, [_vm._v(" " + _vm._s(scope.row.slab45) + " ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "slab60",
      label: "46-60 days",
      align: "right",
      width: "100px",
      sortable: "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("span", {
          staticStyle: {
            color: "#b8860b",
            "font-weight": "bold"
          }
        }, [_vm._v(" " + _vm._s(scope.row.slab60) + " ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "slab90",
      label: "61-90 days",
      align: "right",
      width: "100px",
      sortable: "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("span", {
          staticStyle: {
            color: "#d97706",
            "font-weight": "bold"
          }
        }, [_vm._v(" " + _vm._s(scope.row.slab90) + " ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "slab120",
      label: "91-120 days",
      align: "right",
      width: "100px",
      sortable: "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("span", {
          staticStyle: {
            color: "#e65100",
            "font-weight": "bold"
          }
        }, [_vm._v(" " + _vm._s(scope.row.slab120) + " ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "slabAbove",
      label: "120+ days",
      align: "right",
      width: "100px",
      sortable: "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("span", {
          staticStyle: {
            color: "#c62828",
            "font-weight": "bold"
          }
        }, [_vm._v(" " + _vm._s(scope.row.slabAbove) + " ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "mrp",
      label: "MRP",
      width: _vm.flexColumnWidth("mrp", "MRP"),
      align: "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" ₹ " + _vm._s(_vm.formatNumber(scope.row.mrp)) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "Applied Discount",
      width: _vm.flexColumnWidth("discountType", "Applied Discount"),
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [scope.row.discountType === "nett" ? _c("span", [_c("el-tag", {
          attrs: {
            type: "success",
            size: "mini"
          }
        }, [_vm._v("Nett: ₹" + _vm._s(_vm.formatNumber(scope.row.nettDiscount)))])], 1) : scope.row.discountType === "percent" ? _c("span", [_c("el-tag", {
          attrs: {
            type: "warning",
            size: "mini"
          }
        }, [_vm._v("Percent: " + _vm._s(scope.row.percentDiscount) + "%")])], 1) : _c("span", [_c("span", {
          staticStyle: {
            color: "#c0c4cc",
            "font-style": "italic",
            "font-size": "12px"
          }
        }, [_vm._v("No policy")])])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "rate",
      label: "Rate",
      width: _vm.flexColumnWidth("rate", "Rate"),
      align: "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" ₹ " + _vm._s(_vm.formatNumber(scope.row.rate)) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "value",
      label: "Value",
      width: _vm.flexColumnWidth("value", "Value"),
      align: "right",
      sortable: "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" ₹ " + _vm._s(_vm.formatNumber(scope.row.value)) + " ")];
      }
    }])
  })], 1), _c("pagination", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.total > 0,
      expression: "total > 0"
    }],
    attrs: {
      total: _vm.total,
      page: _vm.listQuery.page,
      limit: _vm.listQuery.limit
    },
    on: {
      "update:page": function ($event) {
        return _vm.$set(_vm.listQuery, "page", $event);
      },
      "update:limit": function ($event) {
        return _vm.$set(_vm.listQuery, "limit", $event);
      },
      pagination: _vm.getList
    }
  })], 1) : _vm._e()]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };